// extracted by mini-css-extract-plugin
export var header = "_vl-1";
export var maskBottom = "_vl-6";
export var maskMiddle = "_vl-7";
export var maskTop = "_vl-5";
export var root = "_vl-0";
export var scrollDownButton = "_vl-3";
export var scrollDownButtonHidden = "_vl-4";
export var viewport = "_vl-2";